/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function isObject(x) {
    return x != null && typeof x === 'object';
}
//# sourceMappingURL=isObject.js.map 



//////////////////
// WEBPACK FOOTER
// /Users/Adriannt/Desktop/2021.1/02 participaciones/zm_participaciones/participaciones/node_modules/rxjs/_esm5/util/isObject.js
// module id = ../../../../rxjs/_esm5/util/isObject.js
// module chunks = vendor